/**
 * <cart-cross-sell data-url="/recommendations/products?section_id=cart-cross-sell&product_id=123&intent=related">
 * Fetches related products for the first cart item and injects compact rows
 * with a one-click add button. Adding refreshes the Dawn cart drawer in place.
 */
class CartCrossSell extends HTMLElement {
  connectedCallback() {
    const url = this.getAttribute('data-url');
    if (!url || this.dataset.loaded) return;
    this.dataset.loaded = 'true';
    this.load(url);
  }

  load(url) {
    fetch(url)
      .then((response) => (response.ok ? response.text() : Promise.reject(response)))
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const inner = html.querySelector('.cart-cross-sell__inner');
        if (inner) {
          this.innerHTML = inner.outerHTML;
          this.bind();
        }
      })
      .catch(() => {
        /* silently ignore — cross-sell is non-critical */
      });
  }

  bind() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cross-add]');
      if (!button || button.disabled) return;
      this.addVariant(button);
    });
  }

  addVariant(button) {
    const id = button.getAttribute('data-variant-id');
    if (!id) return;

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map((section) => section.id)
      : [];

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ id: id, quantity: 1, sections: sections, sections_url: window.location.pathname }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || 'Could not add to cart');
        if (drawer && typeof drawer.renderContents === 'function' && sections.length) {
          drawer.renderContents(data);
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(() => {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  }
}

if (!customElements.get('cart-cross-sell')) {
  customElements.define('cart-cross-sell', CartCrossSell);
}
